import React, { useEffect, useState } from "react";
import ConsultationModal from "./ConsultationModal";

const Hero = () => {
    const [slideIndex, setSlideIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const slides = [
        "img/hero.png",
        "img/hero4.png",
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setSlideIndex((prev) => (prev + 1) % slides.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [slides.length]);

    return (
        <div className="bg-white">
            <div className="relative isolate overflow-hidden">
                <div
                    className="mt-[-50px] flex items-center justify-between container md:flex-row flex-col max-md:pt-36 max-md:pb-24">
                    <div
                        className="max-w-full md:h-screen flex flex-col justify-center flex-shrink-0 px-4 text-center lg:mx-0 lg:max-w-3xl lg:pt-8">
                        <div className="pt-20 flex flex-col items-start justify-center">
                            <div
                                className="mt-10 flex flex-col text-5xl tracking-tight text-gray-700 sm:text-5xl max-w-xl text-right gap-4 font-custom font-black">
                                <span> جلب <span className="text-primary pl-2">توجه</span> از هر مسیری </span>
                            </div>
                            <p className="text-[#6a6a6a] mt-8 text-xl text-right max-w-xl opacity-80 font-custom font-medium">
                                تبلیغات خود را به سادگی و با اثرگذاری بالا در تمامی مسیرهای شهری به نمایش بگذارید.
                            </p>
                            <button
                                onClick={() => setShowModal(true)}
                                className="mt-10 flex justify-between gap-7 border rounded-2xl items-center p-6 pt-7 cursor-pointer hover:bg-primary transition duration-300"
                            >
                                دریافت مشاوره رایگان
                                <svg className="-mt-1" width="20px" height="100%" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2"
                                        strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div
                        className="relative flex justify-end items-center overflow-hidden max-md:px-5 w-full h-[300px]">
                        {slides.map((src, index) => (
                            <div
                                key={index}
                                className={`absolute transition-opacity duration-1000 ${index === slideIndex ? 'opacity-100' : 'opacity-0'} w-[500px] max-md:w-[90%]`}
                            >
                                <img
                                    src={src}
                                    alt={`عکس ماشین‌های درچسب ${index + 1}`}
                                    className="w-full h-auto object-contain"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <ConsultationModal isOpen={showModal} onClose={() => setShowModal(false)} />
        </div >
    );
};

export default Hero;
